// import ErrorTypes from "./../constants/error";
import { toast } from "react-toastify";
import i18n from "i18next";

function getError(error) {
  let save_error = JSON.parse(JSON.stringify(error));
  if (error.message) {
    if (error.message === "Cannot read property 'reduce' of undefined") return;

    if (error.message.includes("The final answer")) {
      error.message = "The final answer";
    }

    if (
      error.message.includes("The first operation cannot be multiplication")
    ) {
      error.message = "The first operation cannot be multiplication";
    }
    if (
      error.message.includes("results in an intermediate answer less than zero")
    ) {
      error.message = "results in an intermediate answer less than zero";
    }
    if (
      error.message ===
      "Error request: This group does not belong to the user who is requesting"
    ) {
      error.message =
        "This group does not belong to the user who is requesting";
    }
    if (
      error.message ===
      "Error request: Referred friend must be created later than whoever studies in Soroban"
    ) {
      error.message = "later than whoever studies in Soroban";
    }
    if (error.message.includes("The teacher has students")) {
      error.message = "The teacher has students";
    }
    if (error.message.includes("already in this family for confirmation")) {
      error.message = "already in this family for confirmation";
    }

    if (error.message.includes("student is already in this family")) {
      error.message = "student is already in this family";
    }

    if (error.message.includes("already listed as a referral")) {
      error.message = "this student is already listed as a referral";
    }
    if (error.message.includes("couldn't get school"))
      error.message = "couldn't get school";
    if (error.message.includes("Invalid parameter phone"))
      error.message = "Invalid parameter phone";
    if (error.message.includes("couldn't get fop"))
      error.message = "couldn't get fop";
    if (error.message.includes("couldn't get Uid book"))
      error.message = "couldn't get Uid book";
    if (error.message.includes("than the attached apprentice")) {
      error.message =
        "the apprentice created earlier than the attached apprentice";
    }
  }

  let translate = {
    "The final answer": "biba",
    "The first operation cannot be multiplication": "biba",
    "results in an intermediate answer less than zero": i18n.t(
      "error.results in an intermediate answer less than zero"
    ),
    "This group does not belong to the user who is requesting": i18n.t(
      "error.This group does not belong to the user who is requesting"
    ),
    "later than whoever studies in Soroban": i18n.t(
      "error.later than whoever studies in Soroban"
    ),
    "already in this family for confirmation": i18n.t(
      "error.already in this family for confirmation"
    ),
    "this student is already listed as a referral": i18n.t(
      "error.this student is already listed as a referral"
    ),
    "the apprentice created earlier than the attached apprentice": i18n.t(
      "error.the apprentice created earlier"
    ),
    "couldn't get Uid book": i18n.t("error.couldn't get Uid book"),
    "couldn't get fop": i18n.t("error.no fop found"),
    "Invalid parameter phone": i18n.t("error.Invalid parameter phone"),
    "couldn't get school": i18n.t("error.couldn't get school"),
    "fop keys is not defined": i18n.t("error.fop keys is not defined"),
    "Wrong password": i18n.t("error.wrong_password"),
    "Wrong email": i18n.t("error.wrong_email"),
    "Invalid data passed": i18n.t("error.invalid_data_passed"),
    "transaction_key is outdated": i18n.t("error.transaction_key_is_outdated"),
    "transaction_key was corrupted": i18n.t(
      "error.transaction_key_was_corrupted"
    ),
    "Not find user": i18n.t("error.not_find_user"),
    "refresh_token is required": i18n.t("error.refresh_token_is_required"),
    "Token recovery is not subject to": i18n.t(
      "error.token_recovery_is_not_subject_to"
    ),
    "Incorrect data": i18n.t("error.incorrect_data"),
    "Method not allowed": i18n.t("error.Method not allowed"),
    "token is required": i18n.t("error.token_is_required"),
    "Token is outdated": i18n.t("error.token_is_outdated"),
    "Unauthorized, token was corrupted": i18n.t(
      "error.unauthorized_token_was_corrupted"
    ),
    "Failed to fetch": i18n.t("error.failed_to_fetch"),
    "Wrong templates data": i18n.t("error.Wrong templates data"),
    "Only zero": i18n.t("payments.enter_payment_amount"),
    "Error assign uid": i18n.t("error.Error assign uid"),
    "This uid does not exist": i18n.t("error.This uid does not exist"),
    "Uid was already attached to another student": i18n.t(
      "error.Uid was already attached to another student"
    ),
    "No homework found for this day": i18n.t(
      "error.No homework found for this day"
    ),
    "The teacher has students": i18n.t("error.the_teacher_has_students"),
    "Token has been changed": i18n.t("error.Token has been changed"),
    "Error getting student office": i18n.t(
      "error.Error getting student office"
    ),
    "The student received a card within a week": i18n.t(
      "error.The student received a card within a week"
    ),
    "Transaction error: the franchisee is currently processing a transaction": i18n.t(
      "error.the franchisee is currently processing a transaction"
    ),
    "Error: balance student is negative": i18n.t(
      "error.balance student is negative"
    ),
  };

  if (error.message === "The final answer") {
    translate["The final answer"] = `${i18n.t("error.digits_task_error_0")} ${
      save_error.message.split("The final answer: ")[1].split(",")[0]
    } ${i18n.t("error.digits_task_error_1")}`;
  }

  if (error.message === "The first operation cannot be multiplication") {
    translate["The first operation cannot be multiplication"] = `${i18n.t(
      "error.mult_task_error"
    )} - ${
      save_error.message.split(
        "The first operation cannot be multiplication - "
      )[1]
    }`;
  }
  if (error.message === "results in an intermediate answer less than zero") {
    translate["results in an intermediate answer less than zero"] = `${i18n.t(
      "error.template_error"
    )} ${
      save_error.message.split("Operations: ")[1].split(" results")[0]
    } ${i18n.t("error.results in an intermediate answer less than zero")}`;
  }
  toast.error(
    error.message
      ? translate[error.message]
        ? translate[error.message]
        : i18n.t("error.unknown_error")
      : translate[error]
      ? translate[error]
      : i18n.t("error.unknown_error")
  );
}

function getSuccess(success) {
  toast.success(!success ? i18n.t("text.success") : success);
}

function getNotification(text) {
  toast.success(text);
}
function getErrorNotification(text) {
  toast.error(text);
}

export { getError, getSuccess, getNotification, getErrorNotification };
